// Contenu légal (FR) — SuccèsNet, plateforme éditée par Agileconnexion inc.

const EDITOR = "Agileconnexion inc.";
const CONTACT = "support@succesnet.com";
const SITE = "www.succesnet.com";
const UPDATED = "3 juillet 2026";

export const LEGAL_PAGES = {
  "mentions-legales": {
    title: "Mentions Légales",
    updated: UPDATED,
    intro: "Conformément aux dispositions légales en vigueur, les informations suivantes sont portées à la connaissance des utilisateurs du site et de l'application SuccèsNet.",
    sections: [
      {
        heading: "1. Éditeur",
        bullets: [
          `Dénomination : ${EDITOR}`,
          "Forme juridique : société par actions (inc.)",
          "Siège social : 310-1200 boulevard Pie-XI Sud, Québec (Québec) G3K 0W2, Canada",
          "Numéro d'entreprise du Québec (NEQ) : 1179249397",
          `Adresse électronique : ${CONTACT}`,
          "Responsable de la publication : Doua Firmin GON",
        ],
      },
      {
        heading: "2. Hébergement",
        bullets: [
          "Le site et l'application sont hébergés sur l'infrastructure infonuagique de la plateforme Emergent.",
        ],
      },
      {
        heading: "3. Objet du service",
        text: `SuccèsNet est une plateforme numérique permettant aux micro-entrepreneurs et commerçants de gérer leurs stocks, leurs commandes, leur vitrine en ligne et leurs paiements. La plateforme met à disposition des outils ; elle n'est pas vendeuse des produits proposés par les marchands utilisateurs.`,
      },
      {
        heading: "4. Propriété intellectuelle",
        text: `L'ensemble des éléments du site et de l'application (marque « SuccèsNet », logo, textes, interfaces, code) est la propriété exclusive de ${EDITOR} ou de ses partenaires. Toute reproduction ou représentation, totale ou partielle, sans autorisation écrite préalable, est interdite. Les contenus déposés par les marchands (photos de produits, descriptions) restent leur propriété.`,
      },
      {
        heading: "5. Données personnelles",
        text: `Les données personnelles collectées sont traitées conformément à notre politique de confidentialité et aux lois applicables sur la protection des renseignements personnels. Tout utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données en écrivant à ${CONTACT}.`,
      },
      {
        heading: "6. Contact",
        text: `Pour toute question relative au site ou à l'application, vous pouvez nous contacter à l'adresse : ${CONTACT} — Site : ${SITE}.`,
      },
    ],
  },

  "cgv": {
    title: "Conditions Générales de Vente et d'Utilisation",
    updated: UPDATED,
    intro: `Les présentes Conditions Générales (ci-après « CGV/CGU ») régissent l'utilisation de la plateforme SuccèsNet, éditée par ${EDITOR}, par ses utilisateurs marchands. Toute inscription implique l'acceptation pleine et entière des présentes conditions.`,
    sections: [
      {
        heading: "1. Définitions",
        bullets: [
          "« Plateforme » : le site et l'application SuccèsNet.",
          "« Éditeur » : la société Agileconnexion inc.",
          "« Marchand » : tout professionnel inscrit utilisant la plateforme pour gérer et promouvoir son activité.",
          "« Client final » : la personne qui achète un produit auprès d'un Marchand.",
        ],
      },
      {
        heading: "2. Objet",
        text: "La plateforme fournit au Marchand des outils de gestion de stock, de calcul du coût de revient, de création d'une vitrine en ligne, de gestion des commandes, de notifications (WhatsApp/email) et d'encaissement via des prestataires de paiement tiers (Mobile Money, Stripe).",
      },
      {
        heading: "3. Inscription et compte",
        bullets: [
          "Le Marchand garantit l'exactitude des informations fournies lors de l'inscription.",
          "Le Marchand est seul responsable de la confidentialité de ses identifiants.",
          "Un compte est strictement personnel ; toute activité réalisée depuis le compte est réputée effectuée par le Marchand.",
        ],
      },
      {
        heading: "4. Formules et tarifs",
        bullets: [
          "Formule Base (gratuite) : accès aux fonctionnalités standard de la plateforme (stocks, vitrine, commandes, tableau de bord, Copilote).",
          "Formule Premium : en plus des fonctionnalités standard, accès à des services additionnels (emballages personnalisés, accès à des produits sourcés, coaching et formations, facilitation d'accès au financement auprès de partenaires).",
          "Pour les formules Base et Premium, la plateforme prélève une commission de 2,5 % sur chaque vente réalisée via la plateforme. Cette commission est non remboursable.",
          "Formule Prestige : accompagnement haut de gamme dont les conditions financières sont définies au cas par cas dans le cadre d'une entente particulière conclue entre le Marchand et l'Éditeur.",
          "Les frais éventuels des prestataires de paiement (opérateurs Mobile Money, Stripe) s'ajoutent à cette commission.",
        ],
      },
      {
        heading: "5. Paiements",
        text: "Les paiements sont traités par des prestataires tiers (opérateurs Mobile Money, Stripe). L'Éditeur n'a pas accès aux données bancaires complètes des utilisateurs. Les délais et frais éventuels de ces prestataires s'appliquent.",
      },
      {
        heading: "6. Relation Marchand / Client final",
        text: "La plateforme est un intermédiaire technique. Les ventes conclues entre un Marchand et ses Clients finaux relèvent de la seule responsabilité du Marchand (conformité, qualité, livraison, service après-vente, garanties légales). L'Éditeur n'est pas partie à ces ventes et ne saurait être tenu responsable des litiges qui en découlent.",
      },
      {
        heading: "7. Obligations du Marchand",
        bullets: [
          "Respecter les lois et règlements applicables à son activité (fiscalité, consommation, etc.).",
          "Ne pas vendre de produits illicites, contrefaits ou dangereux.",
          "Fournir des informations exactes sur ses produits et prix.",
          "Traiter les commandes et réclamations de ses Clients finaux avec diligence.",
        ],
      },
      {
        heading: "8. Responsabilité",
        text: "La plateforme est fournie « en l'état ». L'Éditeur s'efforce d'assurer sa disponibilité mais ne garantit pas une absence totale d'interruption. Sa responsabilité ne saurait être engagée pour les dommages indirects, ni pour les manquements des prestataires tiers ou des Marchands.",
      },
      {
        heading: "9. Durée et résiliation",
        text: `Le Marchand peut cesser d'utiliser la plateforme et demander la suppression de son compte à tout moment en écrivant à ${CONTACT}. L'Éditeur peut suspendre ou résilier un compte en cas de manquement aux présentes conditions.`,
      },
      {
        heading: "10. Droit applicable et juridiction",
        text: "Les présentes CGV/CGU régissent uniquement la relation entre l'Éditeur (SuccèsNet) et le Marchand utilisateur de la plateforme. Elles sont régies par les lois de la province de Québec et du Canada, sans préjudice des dispositions impératives de protection applicables dans le pays de résidence du Marchand. Tout litige entre l'Éditeur et le Marchand fera d'abord l'objet d'une tentative de règlement amiable ; à défaut, les tribunaux du district judiciaire de Québec (Canada) seront compétents.\n\nLes ventes réalisées entre un Marchand et ses propres clients ne sont pas régies par les présentes conditions. Chaque Marchand est seul responsable de ses conditions de vente, et tout litige entre un Marchand et son client relève du droit et des juridictions applicables localement à cette vente. SuccèsNet agit uniquement comme fournisseur d'outils techniques et n'est pas partie au contrat de vente conclu entre le Marchand et son client.",
      },
    ],
  },

  "politique-remboursement": {
    title: "Politique de Remboursement",
    updated: UPDATED,
    intro: "La présente politique précise les modalités de remboursement applicables, en distinguant l'utilisation de la plateforme SuccèsNet et les ventes de produits réalisées par les Marchands auprès de leurs Clients finaux.",
    sections: [
      {
        heading: "1. Commission de la plateforme et formules",
        bullets: [
          "Pour les formules Base et Premium, la plateforme prélève une commission de 2,5 % sur chaque vente réalisée via SuccèsNet. Cette commission est définitive et non remboursable.",
          "La formule Prestige fait l'objet d'une entente particulière entre le Marchand et l'Éditeur ; ses modalités financières et de remboursement éventuel sont précisées dans cette entente.",
          `Pour toute question relative à la commission ou aux services de la plateforme, écrivez à ${CONTACT} en indiquant l'adresse du compte concerné.`,
        ],
      },
      {
        heading: "2. Ventes de produits (Marchand → Client final)",
        text: "SuccèsNet est une plateforme technique et n'est pas vendeuse des produits. Les remboursements de produits achetés auprès d'un Marchand relèvent de la seule responsabilité de ce Marchand, selon sa propre politique de retour et les lois applicables. Le Client final doit s'adresser directement au Marchand concerné.",
      },
      {
        heading: "3. Paiements Mobile Money",
        text: "Pour les paiements réalisés via Mobile Money (Wave, MTN, Orange Money, etc.), les délais et modalités de remboursement dépendent également des règles de l'opérateur concerné. Le Marchand traite la demande et procède, le cas échéant, au remboursement de son Client final.",
      },
      {
        heading: "4. Cas de litige",
        text: `En cas de désaccord sur un remboursement de produit, le Client final et le Marchand s'efforcent de trouver une solution amiable. SuccèsNet peut, à titre de bonne volonté, faciliter la communication, sans être tenu de rembourser une transaction à laquelle il n'est pas partie.`,
      },
      {
        heading: "5. Contact",
        text: `Pour toute question relative aux remboursements liés aux services de la plateforme : ${CONTACT}.`,
      },
    ],
  },

  "politique-confidentialite": {
    title: "Politique de Confidentialité",
    updated: UPDATED,
    intro: `La protection de vos renseignements personnels est une priorité pour ${EDITOR}, éditeur de SuccèsNet. La présente politique explique quelles données nous recueillons, pourquoi, comment nous les utilisons et protégeons, ainsi que les droits dont vous disposez. Elle est établie conformément à la Loi 25 (Loi modernisant des dispositions législatives en matière de protection des renseignements personnels, Québec/Canada) et au Règlement Général sur la Protection des Données (RGPD, Union européenne).`,
    sections: [
      {
        heading: "1. Responsable du traitement",
        bullets: [
          `Responsable du traitement / des renseignements personnels : ${EDITOR}`,
          "Siège social : 310-1200 boulevard Pie-XI Sud, Québec (Québec) G3K 0W2, Canada",
          "Responsable de la protection des renseignements personnels : Doua Firmin GON",
          `Contact (exercice de vos droits, questions) : ${CONTACT}`,
        ],
      },
      {
        heading: "2. Renseignements que nous recueillons",
        bullets: [
          "Données de compte marchand : nom de la boutique, nom, adresse électronique, mot de passe (chiffré), pays, numéro WhatsApp.",
          "Données de la boutique : produits, photos, prix, stocks, zones de livraison, moyens de paiement configurés.",
          "Données de commande et de clients finaux (fournies par le marchand ou saisies par le client) : nom, téléphone, adresse de livraison, contenu de la commande.",
          "Données de paiement : traitées par nos prestataires (Stripe, opérateurs Mobile Money) ; nous n'avons jamais accès aux numéros complets de carte bancaire.",
          "Données techniques : identifiant de session, journaux de connexion, informations relatives à l'appareil et au navigateur.",
        ],
      },
      {
        heading: "3. Finalités et bases légales",
        bullets: [
          "Fournir et exploiter le service (gestion de compte, boutique, commandes) — exécution du contrat.",
          "Envoyer des notifications transactionnelles (WhatsApp, courriel) liées aux commandes — exécution du contrat / intérêt légitime.",
          "Traiter les paiements via nos prestataires — exécution du contrat.",
          "Assurer la sécurité, prévenir la fraude et respecter nos obligations légales — obligation légale / intérêt légitime.",
          "Améliorer la plateforme et fournir l'assistance — intérêt légitime.",
          "Vérification du numéro par code (OTP) — consentement / exécution du contrat.",
        ],
      },
      {
        heading: "4. Communication à des tiers",
        text: "Nous ne vendons pas vos renseignements personnels. Nous les communiquons uniquement aux prestataires nécessaires au fonctionnement du service, dans la limite du besoin :",
        bullets: [
          "Hébergement infonuagique : plateforme Emergent.",
          "Paiements : Stripe et opérateurs Mobile Money (Wave, MTN, Orange Money, etc.).",
          "Messagerie et notifications : Twilio (WhatsApp/SMS), Resend (courriels).",
          "Fonctionnalités d'intelligence artificielle (aperçus produits, assistant) : prestataires de génération d'images et de texte (FASHN, Google Gemini).",
          "Autorités publiques, lorsque la loi l'exige.",
        ],
      },
      {
        heading: "5. Transfert hors du Québec / de l'Union européenne",
        text: `Certains de nos prestataires sont situés hors du Québec et de l'Union européenne (notamment aux États-Unis). Avant toute communication hors Québec, ${EDITOR} évalue que les renseignements bénéficient d'une protection adéquate, au moyen d'engagements contractuels et de garanties appropriées (clauses contractuelles types), conformément à la Loi 25 et au RGPD.`,
      },
      {
        heading: "6. Durée de conservation",
        text: "Nous conservons vos renseignements aussi longtemps que votre compte est actif et pour la durée nécessaire aux finalités décrites, puis selon les délais légaux applicables (obligations comptables et fiscales notamment). À l'expiration de ces délais, les renseignements sont détruits ou anonymisés de manière sécuritaire.",
      },
      {
        heading: "7. Vos droits",
        bullets: [
          "Droit d'accès à vos renseignements personnels.",
          "Droit de rectification des renseignements inexacts ou incomplets.",
          "Droit de suppression (effacement) et droit à l'oubli / désindexation.",
          "Droit à la portabilité de vos données dans un format technologique structuré et couramment utilisé.",
          "Droit de retirer votre consentement à tout moment, sans effet rétroactif.",
          "Droit d'opposition et de limitation du traitement pour un motif légitime.",
          `Pour exercer ces droits, écrivez à ${CONTACT}. Nous répondons dans les délais prévus par la loi (au plus tard 30 jours). Vous pouvez également déposer une plainte auprès de la Commission d'accès à l'information du Québec (CAI) ou, dans l'UE, auprès de votre autorité de protection des données.`,
        ],
      },
      {
        heading: "8. Décisions automatisées",
        text: "Les fonctionnalités d'intelligence artificielle (par exemple les aperçus produits ou l'assistant) produisent des contenus d'aide et ne prennent aucune décision produisant des effets juridiques vous concernant. Aucune décision fondée exclusivement sur un traitement automatisé n'est prise à votre égard sans intervention humaine.",
      },
      {
        heading: "9. Témoins de connexion (cookies) et technologies similaires",
        text: "Nous utilisons un témoin de session strictement nécessaire à votre connexion et au fonctionnement du service, ainsi qu'un stockage local (localStorage) pour maintenir votre session, notamment sur les navigateurs mobiles. Nous n'utilisons pas de cookies publicitaires de suivi.",
      },
      {
        heading: "10. Sécurité",
        text: "Nous mettons en œuvre des mesures de sécurité raisonnables (chiffrement des mots de passe, transport chiffré HTTPS, contrôle des accès) pour protéger vos renseignements contre la perte, l'accès non autorisé ou la divulgation. En cas d'incident de confidentialité présentant un risque de préjudice sérieux, nous en aviserons les personnes concernées et les autorités compétentes conformément à la Loi 25 et au RGPD.",
      },
      {
        heading: "11. Renseignements des mineurs",
        text: "La plateforme s'adresse à des professionnels majeurs. Nous ne collectons pas sciemment de renseignements concernant des mineurs.",
      },
      {
        heading: "12. Modifications",
        text: "La présente politique peut être mise à jour pour refléter l'évolution de nos pratiques ou de la réglementation. La date de dernière mise à jour figure en tête de page. En cas de changement important, nous vous en informerons par un moyen approprié.",
      },
      {
        heading: "13. Contact",
        text: `Pour toute question relative à la présente politique ou à vos renseignements personnels, contactez notre responsable de la protection des renseignements personnels à l'adresse : ${CONTACT} — Site : ${SITE}.`,
      },
    ],
  },
};

export const LEGAL_FOOTER_LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/cgv", label: "CGV / CGU" },
  { to: "/politique-confidentialite", label: "Confidentialité" },
  { to: "/politique-remboursement", label: "Remboursement" },
];
